import { Component, Input } from '@angular/core';
import { SvgIconComponent } from '../svg-icon/svg-icon.component';
import { CommonModule, Location } from '@angular/common';
import { ButtonComponent } from '../button/button.component';
import { RouterModule, Router } from '@angular/router';
import { Store } from '@ngrx/store';

export interface IBreadcrumb {
  label: string;
  link?: string;
}

@Component({
  selector: 'ui-page-header',
  standalone: true,
  imports: [CommonModule, RouterModule, ButtonComponent, SvgIconComponent],
  templateUrl: './page-header.component.html',
  styleUrls: ['./page-header.component.scss'],
})
export class PageHeaderComponent {
  @Input() title = '';
  @Input() titleTag = '';
  @Input() titleTagType: 'secondary' | 'info' | 'success' | 'warning' | 'danger' = 'secondary';
  @Input() icon = '';
  @Input() showBackButton = false;
  @Input() breadcrumbs: IBreadcrumb[] = [];
  @Input() titleSize: 'large' | 'xlarge' = 'large';

  constructor(
    private location: Location,
    private router: Router
  ) {}

  onBackButtonClick() {
    if (this.breadcrumbs.length > 0 && this.breadcrumbs[this.breadcrumbs.length - 1].link) {
      this.router.navigate([this.breadcrumbs[this.breadcrumbs.length - 1].link!], {
        queryParamsHandling: 'merge',
      });
    } else {
      this.location.back();
    }
  }
}
